import * as React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { brandColors } from 'brandColors';
import { Message } from './Message';

export const Matched: React.FC = () => {
  return (
    <Message>
      <CheckIcon style={{ fontSize: '16px', fill: brandColors.colors.green.DEFAULT }} />
      <h4>Reference ID column was detected and automatically matched.</h4>
    </Message>
  );
};
Matched.displayName = 'CustomerAssignment.Message.Matched';
